module.exports = __webpack_public_path__ + "media/images/sp/stores/fuji/fuji_sns_03-0fb0f7b62941674bf1a8057471225ac9.jpg";